import { ActionMenu } from "@/components/ActionMenu.tsx";
import { Spacer } from "@/components/Spacer.tsx";
import { WButton } from "@/components/button/WButton.tsx";
import type { SortFieldInfo, SortState } from "@/components/data/getSortedItems.ts";
import { MaskIcon } from "@/components/icon/MaskIcon.tsx";
import { useLingui } from "@lingui/react/macro";
import { findById } from "@warrenio/utils/collections/findById";

export interface SortMenuProps extends SortState {
    sortFields: SortFieldInfo[];

    onSortId: (id: string) => void;
    onSortAsc: (asc: boolean) => void;
}

export function SortMenu({ sortFields, sortId, onSortId, sortAsc = true, onSortAsc }: SortMenuProps) {
    const { t } = useLingui();
    const currentSort = findById(sortFields, sortId);
    const currentSortName = currentSort?.title;

    return (
        <>
            <WButton
                ariaLabel="Sort direction"
                color="muted"
                variant="ghost"
                size="xs"
                fontSize="font-size-small"
                icon={sortAsc ? "jp-icon-caretdown" : "jp-icon-caretup"}
                iconSide="right"
                action={() => onSortAsc?.(!sortAsc)}
            >
                {currentSortName}
            </WButton>
            <Spacer />
            <ActionMenu
                header={t`Sort by`}
                onAction={({ id }) => onSortId(id)}
                selectedKeys={[sortId]}
                items={sortFields}
            >
                <WButton color="muted" variant="ghost" size="xs" ariaLabel="Sort by" action={undefined}>
                    <MaskIcon className="jp-icon-toggles size-0.75rem" />
                </WButton>
            </ActionMenu>
        </>
    );
}
